import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ActiveToast, ToastType, ToastTypeName } from '@pso-ui/toast-notification/Toast';

@Injectable({
  providedIn: 'root',
})
export class ToastNotificationService {
  private nextId = 0;
  readonly toasts$ = new BehaviorSubject<ActiveToast[]>([]);

  constructor(private translateService: TranslateService) {}

  show(message: string, type: ToastTypeName): void {
    const duration = Math.max(10000, Math.ceil(message.length / 50) * 5000);
    const id = this.nextId++;
    const toast: ActiveToast = { id, message: this.translateService.instant(message), type, duration };
    this.toasts$.next([...this.toasts$.getValue(), toast]);
    setTimeout(() => this.dismiss(id), duration);
  }

  dismiss(id: number): void {
    this.toasts$.next(this.toasts$.getValue().filter((t) => t.id !== id));
  }

  showError(message: string): void {
    this.show(message, ToastType.ERROR);
  }

  showWarning(message: string): void {
    this.show(message, ToastType.WARNING);
  }

  showSuccess(message: string): void {
    this.show(message, ToastType.SUCCESS);
  }

  showInfo(message: string): void {
    this.show(message, ToastType.INFO);
  }
}
